export const PERIOD_UNAVAILABILITYS = "/api/unavailabilities-periods"
export const PERIOD_UNAVAILABILITY = "/api/unavailabilities-periods/:param"
export const EXPORT_PERIOD_UNAVAILABILITY = "/api/unavailabilities-periods/export"
export const IMPORT_PERIOD_UNAVAILABILITY = "/api/unavailabilities-periods/import"
